@if (!!log && hasLog(PolicySignersKeys.policyType, log)) {
  <p class="fw-bold">New {{ log[PolicySignersKeys.policyType] | lookupDescriptionText: policyTypesLookup}} was accepted.</p>

  <p *ngIf="!log[PolicySignersKeys.lastSignedVersion]; else lastSignedVersion">
    Accepted version is
    <span class="ag-change-log-detail--new-value">{{ log[PolicySignersKeys.policyVersion] }}</span>.
  </p>

  <ng-template #lastSignedVersion>
    <p>
      Version was changed from <span
      class="ag-change-log-detail--old-value">{{ log[PolicySignersKeys.lastSignedVersion] }}</span> to <span
      class="ag-change-log-detail--new-value">{{ log[PolicySignersKeys.policyVersion] }}</span>.
    </p>
  </ng-template>
}
